export class Permission {
  levelModulePermissionId: string;
  name: string;
  urlSgc1: string;
  urlSgc2: string;
  parentId: string;
  redirectToSgc1: boolean;
  levelPermissions: string[];
  position: number;
}

export class PermissionRequest {
  levelModulePermissionId: string;
  Level0: boolean;
  Level1: boolean;
  Level2: boolean;
  Level3: boolean;
  Level4: boolean;
  Level5: boolean;
  Level6: boolean;
}
